import React, { useMemo } from "react";
import { useTranslations } from "next-intl";
import boldMatch from "../../common/utils/boldMatch";
import { Link } from "../../../navigation";
import Image from "next/image";
import { toCockpitImagePath } from "../../cms/components/CockpitImage";
import noImage from "../../../../public/img/no-image.jpg";
import DOMRenderer from "../../cms/components/DOMRenderer";

// to make it work with previous results
const typeNameToCollectionNameMap = {
  PostsModel: "news",
  academyModel: "events",
};

const SuggestedContentListItem = ({ content, searchTerm }) => {
  const t = useTranslations();
  let imagePath;
  if (content?.collectionName === "pages")
    imagePath = content?.seo?.image?.path;
  if (content?.collectionName === "events") imagePath = content?.image?.path;
  if (content?.collectionName === "news") imagePath = content?.cover?.path;

  const CollectionToPageIdMap = useMemo(
    () => ({
      news: {
        pageId: "/collections/Posts",
        pageName: t("news"),
        class: "color-bg-primary color-white",
      },
      pages: {
        pageId: "",
      },
      events: {
        pageId: "/collections/academy",
        pageName: t("event"),
        class: "color-bg-primary color-white",
      },
    }),
    [t],
  );
  const normalizedCollectionType =
    content?.collectionName ||
    typeNameToCollectionNameMap?.[content?._typename];
  return (
    <Link
      href={`${CollectionToPageIdMap[normalizedCollectionType]?.pageId}/${content?.slug || content._r || content._id}`}
      key={content?._id}
    >
      <div className="searched-item fs-7 py-2 py-md-1 pr-1 d-flex flex-no-wrap mb-2">
        <Image
          src={toCockpitImagePath(imagePath) || noImage}
          className="h-80px ml-1 cursor-pointer object-fit-cover"
          width={80}
          height={80}
          quality={80}
          alt={content?.title}
        />
        <div className="d-flex align-items-center justify-content-between w-100">
          <div className="mx-3 hyphens-auto">
            <DOMRenderer
              htmlString={boldMatch({
                value: content?.title,
                highlight: searchTerm,
              })}
            />
          </div>
          <div
            className={`d-inline-block fs-8 py-1 px-2 border-radius ${CollectionToPageIdMap[normalizedCollectionType]?.class}`}
          >
            {CollectionToPageIdMap[normalizedCollectionType]?.pageName}{" "}
          </div>
        </div>
      </div>
    </Link>
  );
};

export default SuggestedContentListItem;
